import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  mutation: gql`
    mutation activateCard($cardId: ID!) {
      activateCard(cardId: $cardId) {
        success
      }
    }
  `,
  config: {
    skip: (ownProps) => !ownProps.cardId,
    options: ({ cardId }) => ({
      variables: {
        cardId,
      },
    }),
  },
  propTypes: {
    cardId: PropTypes.string.isRequired,
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/cards/activateCard.js